<template>
  <section>
    <b-modal :active.sync="isComponentModalActive" has-modal-card :can-cancel="false">
      <div class="modal-card">
          <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>
        <header class="modal-card-head">
          <p v-if="!this.location_id" class="modal-card-title">Crear Locacion</p>
          <p v-else class="modal-card-title">Editar Locacion</p>
        </header>
        <section class="modal-card-body">
          <b-field label="Nombre">
            <b-input
              type="text"
              :value="location.name"
              v-model="location.name"
              placeholder="Nombre"
              required
            ></b-input>
          </b-field>
          <b-field label="Establecimiento">
            <b-select placeholder="Seleccionar Establecimiento" v-model="location.stablishment_id" expanded>
              <option
                v-for="stablishment in listStablishment"
                :value="stablishment.id"
                :key="stablishment.id"
              >{{ stablishment.name }}</option>
            </b-select>
          </b-field>                 
        </section>
        <footer class="modal-card-foot">
          <button class="button" type="button" @click="closeBasic()">Cerrar</button>
          <button v-if="!this.location_id" class="button is-primary" @click="createLocation()">Guardar</button>
          <button v-else class="button is-primary" @click="editLocation()">Editar</button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>
<script>
export default {
  props: ["isComponentModalActive", "closeBasic", "chargeListLocations", "location_id"],
  data() {
    return {
      location: {
        name: "",
        stablishment_id: "",
        address:""
      },
      listStablishment: [],
      listRoles: [],
      isLoading:false
    };
  },
  created: function() {
    this.isLoading=true;
    this.chargeLists().then(() => {
      if (this.location_id) {
        this.chargeUserData().then(()=>{
          this.isLoading=false;
        });
      }else{
        this.isLoading=false;
      }
    });
  },
  methods: {
    createLocation: async function() {
      this.isLoading=true;
      let data = {
        ...this.location
      };
      await this.$http.post(`api/${localStorage.getItem('perfil')}/location`, data).then(
        response => {
          //Limpia el objeto location
          for (const i in this.location) {
            this.location[i] = "";
          }
          console.log("POST:", response.body);
          this.chargeListLocations();
          this.closeBasic();
          this.toast("Creado el usuario", "is-success");
          this.isLoading=false;
        },
        response => {
          this.toast("error al crear", "is-danger");
          this.isLoading=false;
          console.log("error: ", response);
        }
      );
    },
    editLocation: function() {
      this.isLoading=true;
      let data = {
        ...this.location
      };
      this.$http.put(`api/${localStorage.getItem('perfil')}/location/` + this.location_id, data).then(
        response => {
          //Limpia el objeto location
          for (const i in this.location) {
            this.location[i] = "";
          }
          console.log("PUT:", response.body);
          this.chargeListLocations();
          this.closeBasic();
          this.toast("Editado el Usuario", "is-success");
          this.isLoading=false;
        },
        response => {
          this.toast("error al editar", "is-danger");
          this.isLoading=false;
          console.log("error: ", response);
        }
      );
    },
    chargeLists: async function() {
      await this.$http.get(`api/${localStorage.getItem('perfil')}/stablishment`).then(
        response => {
          this.listStablishment = response.body.data;
          console.log(this.listStablishment);
        },
        response => {
          console.log("error: ", response);
        }
      );
    },
    chargeUserData: async function() {
      await this.$http.get(`api/${localStorage.getItem('perfil')}/location/` + this.location_id).then(
        response => {
          (this.location.name = response.body.location.name),
            (this.location.stablishment_id = response.body.location.stablishment_id),
            (this.location.address=response.body.location.address)
        },
        response => {
          console.log(response);
        }
      );
    }
  }
};
</script>